import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  L: number;
  H: number;
  h: number;
  l: number;
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.ABUTMENT,
  image: "/images/assets/culée.png",
  submittedBy: SubmittingOrganization.ARS,
  inputs: [
    {
      key: "L",
      type: "dimension",
    },
    {
      key: "H",
      type: "dimension",
    },
    {
      key: "h",
      type: "dimension",
    },
    {
      key: "l",
      type: "dimension",
    },
  ],
  build: (params, offset) => {
    const { L, H, h, l } = params;
    return [
      {
        // center parallelogram
        type: "polyline",
        points: [
          [
            // bottom Left
            offset[0] - L / 2,
            offset[1] - H / 2,
            offset[2],
          ],
          [
            // bottom right
            offset[0] + L / 2,
            offset[1] - H / 2,
            offset[2],
          ],
          [
            // top right
            offset[0] + L / 2,
            offset[1] + H / 2,
            offset[2],
          ],
          [
            // right redan top
            offset[0] + L / 2 - l,
            offset[1] + H / 2,
            offset[2],
          ],
          [
            // right redan bottom
            offset[0] + L / 2 - l,
            offset[1] + H / 2 - h,
            offset[2],
          ],
          [
            // left redan bottom
            offset[0] - L / 2 + l,
            offset[1] + H / 2 - h,
            offset[2],
          ],
          [
            // left redan top
            offset[0] - L / 2 + l,
            offset[1] + H / 2,
            offset[2],
          ],
          [
            // top left
            offset[0] - L / 2,
            offset[1] + H / 2,
            offset[2],
          ],
          [
            // top left
            offset[0] - L / 2,
            offset[1] - H / 2,
            offset[2],
          ],
        ],
      },
    ];
  },
};

export default asset;
